import { QueryClient } from '@tanstack/react-query';

import prefetchBaseQuery from './prefetchBaseQuery';
import useBaseMutation from './useBaseMutation';
import useBaseQuery from './useBaseQuery';

// Create a client
const queryClient = new QueryClient();

export {
  prefetchBaseQuery,
  queryClient,
  useBaseMutation,
  useBaseQuery,
};
